// ORDER-SUMMARY.JS
class ShippingCalculatorSplit {
  constructor(productId, productData) {
    this.productId = productId;
    this.productData = productData;
    this.currentVariant = null;
    this.variantPrices = null;
    this.init();
  }

  init() {
    const warehouseHidden = document.getElementById('warehouse-picker-hidden');
    const stateHidden = document.getElementById('state-picker-hidden');
    const warehouseVisible = document.getElementById('warehouse-picker-visible');
    const stateVisible = document.getElementById('state-picker-visible');
    
    if (warehouseHidden) warehouseHidden.value = '';
    if (stateHidden) stateHidden.value = '';
    if (warehouseVisible) warehouseVisible.value = '';
    if (stateVisible) stateVisible.value = '';

    this.warehouseSection = document.querySelector('.warehouse-picker-section');
    this.stateSection = document.querySelector('.state-picker-section');
    this.warehousePicker = document.getElementById('warehouse-picker-visible');
    this.statePicker = document.getElementById('state-picker-visible');
    this.warehouseHidden = document.getElementById('warehouse-picker-hidden');
    this.stateHidden = document.getElementById('state-picker-hidden');
    
    this.addToCartBtn = this.findAddToCartButton();
    this.productForm = document.querySelector('.js-product-form');

    if (!this.warehouseSection || !this.stateSection) {
      return;
    }

    this.warehouseSection.classList.add('hidden');
    this.stateSection.classList.add('hidden');

    this.setupEventListeners();

    setTimeout(() => {
      this.updateShippingCalculator();
    }, 100);
  }

  findAddToCartButton() {
    const selectors = [
      '#add-to-cart-btn',
      'button[name="add"]',
      'button[type="submit"]',
      '.btn--primary',
      '.product-form__submit',
      '.add-to-cart',
      '.js-add-to-cart'
    ];

    for (let selector of selectors) {
      const button = document.querySelector(selector);
      if (button) {
        return button;
      }
    }

    return null;
  }

  setupEventListeners() {
    this.setupVariantTracking();
    this.setupPickerEvents();
    
    if (this.addToCartBtn) {
      this.setupAddToCartValidation();
    }
  }

  setupVariantTracking() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', () => {
        this.updateShippingCalculator();
      });
    }

    document.addEventListener('change', (e) => {
      const target = e.target;
      if (target.name?.includes('option') || 
          target.closest('.product-form__input') || 
          target.closest('.swatch') ||
          target.classList.contains('single-option-selector')) {
        setTimeout(() => this.updateShippingCalculator(), 100);
      }
    });

    this.setupVariantPolling();
  }

  setupVariantPolling() {
    let lastVariantId = this.getCurrentVariantId();
    
    const checkVariantChange = () => {
      const currentVariantId = this.getCurrentVariantId();
      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        this.updateShippingCalculator();
      }
    };

    setInterval(checkVariantChange, 500);
  }

  getCurrentVariantId() {
    const variantInput = document.querySelector('input[name="id"]');
    return variantInput?.value || '';
  }

  setupPickerEvents() {
    if (this.warehousePicker) {
      this.warehousePicker.addEventListener('change', () => {
        this.syncVisibleToHidden('warehouse');
        this.hideError('warehouse-error');
        this.removeErrorField(this.warehousePicker);
      });
    }

    if (this.statePicker) {
      this.statePicker.addEventListener('change', () => {
        this.syncVisibleToHidden('state');
        this.hideError('state-error');
        this.removeErrorField(this.statePicker);
      });
    }
  }

  syncVisibleToHidden(fieldType) {
    if (fieldType === 'warehouse') {
      if (this.warehousePicker && this.warehouseHidden && this.warehousePicker.value) {
        this.warehouseHidden.value = this.warehousePicker.value;
      }
    } else if (fieldType === 'state') {
      if (this.statePicker && this.stateHidden && this.statePicker.value) {
        this.stateHidden.value = this.statePicker.value;
      }
    }
  }

  setupAddToCartValidation() {
    if (!this.addToCartBtn) {
      return;
    }

    this.originalButtonHTML = this.addToCartBtn.innerHTML;
    this.originalButtonDisabled = this.addToCartBtn.disabled;

    this.addToCartBtn.addEventListener('click', (e) => {
      if (!this.validateSelections()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);

    if (this.productForm) {
      this.productForm.addEventListener('submit', (e) => {
        if (!this.validateSelections()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return false;
        }
      }, true);
    }
  }

  updateShippingCalculator() {
    this.currentVariant = this.getCurrentVariant();
    if (!this.currentVariant) {
      return;
    }
    
    const deliveryType = this.getDeliveryType(this.currentVariant);

    this.updateOrderSummary(this.currentVariant, deliveryType);
    this.updatePickerVisibility(deliveryType);
  }

  getCurrentVariant() {
    const variantId = this.getCurrentVariantId();
    if (!variantId) {
      return this.productData.variants[0];
    }

    const variant = this.productData.variants.find(v => v.id == variantId);
    return variant || this.productData.variants[0];
  }

  getDeliveryType(variant) {
    if (!variant) return 'Warehouse Pickup';

    const options = [variant.option1, variant.option2, variant.option3].filter(Boolean);
    
    for (let option of options) {
      const optionLower = option.toLowerCase();
      
      if (optionLower.includes('warehouse') || optionLower.includes('pickup')) {
        return 'Warehouse Pickup';
      } else if (optionLower.includes('business')) {
        return 'Business Delivery';
      } else if (optionLower.includes('residential')) {
        return 'Residential Delivery';
      } else if (optionLower.includes('standard') && optionLower.includes('shipping')) {
        return 'Standard Shipping';
      }
    }

    return 'Warehouse Pickup';
  }

  updateOrderSummary(variant, deliveryType) {
    const variantPrices = this.calculateVariantPrices();
    const variantPrice = variant.price / 100;
    const warehousePrice = variantPrices.warehouse;
    const businessPrice = variantPrices.business;
    const residentialPrice = variantPrices.residential;
    const standardShippingPrice = variantPrices.standardShipping;

    let shippingCost = 0;
    let shippingSurcharge = 0;

    switch(deliveryType) {
      case 'Business Delivery':
        shippingCost = Math.max(0, businessPrice - warehousePrice);
        break;
      case 'Standard Shipping':
        shippingCost = Math.max(0, standardShippingPrice - warehousePrice);
        break;
      case 'Residential Delivery':
        shippingCost = Math.max(0, businessPrice - warehousePrice);
        shippingSurcharge = Math.max(0, residentialPrice - businessPrice);
        break;
      default:
        shippingCost = 0;
    }

    this.updateUIElements(deliveryType, warehousePrice, shippingCost, variantPrice, shippingSurcharge);
  }

  calculateVariantPrices() {
    const variants = this.productData.variants;

    const warehouseVariant = variants.find(v => 
      v.option1 && v.option1.toLowerCase().includes('warehouse')
    );

    const businessVariant = variants.find(v => 
      v.option1 && v.option1.toLowerCase().includes('business')
    );

    const residentialVariant = variants.find(v => 
      v.option1 && v.option1.toLowerCase().includes('residential')
    );

    const standardShippingVariant = variants.find(v => {
      if (!v.option1) return false;
      const option1 = v.option1.toLowerCase();
      return option1.includes('standard') || 
             (option1.includes('shipping') && !option1.includes('business') && !option1.includes('residential'));
    });

    const prices = {
      warehouse: warehouseVariant ? (warehouseVariant.price / 100) : (this.productData.variants[0].price / 100),
      business: businessVariant ? (businessVariant.price / 100) : 0,
      residential: residentialVariant ? (residentialVariant.price / 100) : 0,
      standardShipping: standardShippingVariant ? (standardShippingVariant.price / 100) : 0
    };

    return prices;
  }

  updateUIElements(deliveryType, warehousePrice, shippingCost, variantPrice, shippingSurcharge) {
    const shippingMethodEl = document.getElementById('selected-shipping-method');
    const productPriceEl = document.getElementById('product-price');
    const shippingCostEl = document.getElementById('selected-shipping-cost');
    const totalCostEl = document.getElementById('selected-total-cost');
    const surchargeItem = document.getElementById('surcharge-item');
    const shippingSurchargeEl = document.getElementById('shipping-surcharge');

    if (shippingMethodEl) shippingMethodEl.textContent = deliveryType;
    if (productPriceEl) productPriceEl.textContent = this.formatMoney(warehousePrice);
    if (shippingCostEl) shippingCostEl.textContent = this.formatMoney(shippingCost);
    if (totalCostEl) totalCostEl.textContent = this.formatMoney(variantPrice);

    if (deliveryType === 'Residential Delivery' && shippingSurcharge > 0) {
      if (shippingSurchargeEl) shippingSurchargeEl.textContent = this.formatMoney(shippingSurcharge);
      if (surchargeItem) surchargeItem.classList.remove('hidden');
    } else {
      if (surchargeItem) surchargeItem.classList.add('hidden');
    }
  }

  updatePickerVisibility(deliveryType) {
    this.warehouseSection.classList.add('hidden');
    this.stateSection.classList.add('hidden');

    switch(deliveryType) {
      case 'Warehouse Pickup':
        this.warehouseSection.classList.remove('hidden');
        if (this.stateHidden) {
          this.stateHidden.value = '';
        }
        break;
      case 'Business Delivery':
      case 'Residential Delivery':
      case 'Standard Shipping':
        this.stateSection.classList.remove('hidden');
        if (this.warehouseHidden) {
          this.warehouseHidden.value = '';
        }
        break;
    }
  }

  validateSelections() {
    if (!this.currentVariant) {
      return true;
    }

    const deliveryType = this.getDeliveryType(this.currentVariant);

    this.hideError('warehouse-error');
    this.hideError('state-error');
    this.removeErrorField(this.warehousePicker);
    this.removeErrorField(this.statePicker);

    let isValid = true;

    switch(deliveryType) {
      case 'Warehouse Pickup':
        if (!this.warehousePicker || !this.warehousePicker.value) {
          this.showError('warehouse-error', 'Please select a warehouse');
          this.addErrorField(this.warehousePicker);
          this.scrollToElement(this.warehousePicker);
          isValid = false;
        } else {
          this.syncVisibleToHidden('warehouse');
        }
        break;
        
      case 'Business Delivery':
      case 'Residential Delivery':
      case 'Standard Shipping':
        if (!this.statePicker || !this.statePicker.value) {
          this.showError('state-error', 'Please select a state');
          this.addErrorField(this.statePicker);
          this.scrollToElement(this.statePicker);
          isValid = false;
        } else {
          this.syncVisibleToHidden('state');
        }
        break;
    }

    return isValid;
  }

  showError(errorId, message) {
    const errorElement = document.getElementById(errorId);
    if (errorElement) {
      errorElement.textContent = message;
      errorElement.classList.remove('hidden');
    }
  }

  hideError(errorId) {
    const errorElement = document.getElementById(errorId);
    if (errorElement) {
      errorElement.classList.add('hidden');
    }
  }

  addErrorField(field) {
    if (field) {
      field.classList.add('error-field');
    }
  }

  removeErrorField(field) {
    if (field) {
      field.classList.remove('error-field');
    }
  }

  scrollToElement(element) {
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      element.focus();
    }
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }
}

function initializeShippingCalculator() {
  const shippingCalculator = document.querySelector('.shipping-calculator');
  if (!shippingCalculator) {
    return;
  }

  const productId = shippingCalculator.dataset.productId;
  if (!productId) {
    return;
  }

  const productJsonElement = document.getElementById('ProductJson-' + productId);
  if (!productJsonElement) {
    return;
  }

  try {
    const productData = JSON.parse(productJsonElement.textContent);
    window.shippingCalculator = new ShippingCalculatorSplit(productId, productData);
  } catch (error) {
    return;
  }
}

let initializationAttempted = false;

function initializeOnce() {
  if (initializationAttempted) return;
  initializationAttempted = true;
  setTimeout(initializeShippingCalculator, 500);
}

document.addEventListener('DOMContentLoaded', initializeOnce);
window.addEventListener('load', initializeOnce);